import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Parts-sale operational status palette (design: claude_designs/osamyynti/data.js).
// Financial state (paid/overdue) is NOT here — read it from the linked invoice.
const statusConfig = {
  open: { color: '#3182ce', bgcolor: '#ebf4ff', borderColor: '#bee3f8' },
  invoiced: { color: '#2f8c54', bgcolor: '#e6ffed', borderColor: '#c6f6d5' },
  cancelled: { color: '#e35454', bgcolor: '#fee2e2', borderColor: '#fecaca' },
};

function PartsSaleStatusBadge({ status, size = 'small' }) {
  const { t } = useTranslation();
  const config = statusConfig[status] || statusConfig.open;
  return (
    <Chip
      size={size}
      label={t(`parts_sales.status_${status}`)}
      sx={{
        color: config.color,
        bgcolor: config.bgcolor,
        border: '1px solid',
        borderColor: config.borderColor,
        fontWeight: 600,
        height: size === 'small' ? 22 : 26,
        fontSize: size === 'small' ? 11 : 12,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}

export default PartsSaleStatusBadge;
